module.exports = __webpack_public_path__ + "img/en-flag-32x48.cbc1913a.png";